import $ from 'jquery'
import _ from 'lodash'

import 'app/css/app.scss'
import 'slick-carousel/slick/slick.scss'
import { APPLY_LICENSE_ACCOUNTS  } from '../../../../config/app'

const userAgents = ['iPad', 'iPhone', 'Android', 'IEMobile', 'BlackBerry']
var HTTP_URL = process.env.HTTP_URL

export const isMobile = () => {
	let userAgent
	const isMobile = {
		any: false
	}

	$.each(userAgents, function (index) {
		userAgent = userAgents[index]

		isMobile[userAgent] = navigator.userAgent.toLowerCase().indexOf(userAgent.toLowerCase()) > -1

		if (isMobile[userAgent]) isMobile.any = true
	})

	return isMobile
}

export const mobile = isMobile()

// jQuery Element Object
const $copyRightYear = $('#cr-year')
const $win = $(window)
const $goTop = $('#go-top')
const $header = $('.app-header')
const $navLi = $('.navbar-nav li')
const $toKnow = $('.understand-more:not(#understandBtn)')
const $tryUse = $('.try-use')

function winScroll() {
	const st = $win.scrollTop()
	if (st > 10) {
		setBorder()
	} else {
		setTransparentBorder()
	}
}

function setBorder() {
	$header.addClass('border-bottom-shadow')
}

function setTransparentBorder() {
	$header.removeClass('border-bottom-shadow')
}

// window.addEventListener('load', function () {
//   setActiveNav()
// })

// $navLi.click((e) => {
//   console.log(e, 'ee')
//   console.table($(e.target))
//   $(e.target).addClass('active')
// })

export const setActiveNav = () => {
	const {
		href
	} = window.location
	const inc = name => href.includes(name)
	$navLi.find('a').removeClass('active')
	if (inc('production')) {
		$navLi.find('.production').addClass('active')
	} else if (inc('resolve')) {
		$navLi.find('.resolve').addClass('active')
	} else if (inc('team')) {
		$navLi.find('.team').addClass('active')
	}else if (inc('brother')) {
		$navLi.find('.brother').addClass('active')
	}else if (inc('report')) {
		$navLi.find('.report-nav').addClass('active')
	} else if (inc('comparison')) {
		if (!inc('info')) {
			$navLi.find('.comparison').addClass('active')
		}
	} else if (inc('subscription') || inc('paidtechservice')) {
			$navLi.find('.subscription').addClass('active')
  }else if (inc('us')) {
		$navLi.find('.us').addClass('active')
	} else if (inc('cmp')) {
		$navLi.find('.cmp').addClass('active')
	} else if (inc('private')) {
		$navLi.find('.private').addClass('active')
	} else if (inc('/ai') || inc('ai/')) {
		$navLi.find('.ai').addClass('active')
	} else if (inc('article')) {
		$navLi.find('.article').addClass('active')
	} else if (inc('finops')) {
		$navLi.find('.finops').addClass('active')
	} else {
		$navLi.find('.index').addClass('active')
	}
}


export const initApp = () => {
	$copyRightYear.text(new Date().getFullYear())
	winScroll()
	if (!mobile.any) {
		$win.on('scroll', _.throttle(winScroll, 30))
	} else {
		setBorder()
	}
	$goTop.on('click', function () {
		$('html, body').animate({
			'scrollTop': 0
		})
	})
	$(document).scroll(function () {
		var scroH = $(document).scrollTop(); //滚动高度
		if (scroH > 200) {
			$goTop.css('display', 'flex')
		} else {
			$goTop.css('display', 'none')
		}
	});
	$toKnow.on('click', () => {
		window.open('https://wj.qq.com/s2/3143572/ff8a/')
	})
	$tryUse.on('click', () => {
		window.open('https://wj.qq.com/s2/3143572/ff8a/')
	})
	swiperJs()
	revealInit()
}

// 滚动入场动画：为带有 [data-reveal] 的元素做淡入动效，进出视口可反复播放
const $revealEls = $('[data-reveal]')

const revealInit = () => {
	if (!$revealEls.length) return
	$revealEls.each((_, el) => {
		const delay = el.getAttribute('data-delay')
		if (delay) el.style.setProperty('--reveal-delay', `${delay}ms`)
		// 动画播放完毕后切换为静态展示，避免常驻动画覆盖 hover 位移
		el.addEventListener('animationend', () => {
			el.classList.remove('is-visible')
			el.classList.add('reveal-done')
		})
	})
	if ('IntersectionObserver' in window) {
		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const el = entry.target
				if (entry.isIntersecting) {
					el.classList.add('is-visible')
					el.classList.remove('reveal-done')
				} else {
					el.classList.remove('is-visible', 'reveal-done')
				}
			})
		}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
		$revealEls.each((_, el) => io.observe(el))
	} else {
		$revealEls.addClass('reveal-done')
	}
}


const swiperJs = () => {
	var swiper = new Swiper('.swiper-container', {
		// slidesPerView: 3,
		speed: 800,
		centeredSlides: true,
		loop: true,
		spaceBetween: 30,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	})
}

function openShangqiao() {
	var $ok = $('#nb_invite_ok')
	if ($ok) {
		$ok.click()
	}
}

// 在自定义的按钮执行即可
$('#contact-nvite').click(function () {
	openShangqiao()
})


export const login = () => {
	const href = window.location.href
	const loginUrl = `${HTTP_URL}/auth/login?source=${href}`
	window.location.href = loginUrl
}

export const logout = () => {
	Cookies.remove('yunionauth', {
		domain: '.yunion.cn'
	})
	Cookies.remove('yunionauth', {
		domain: '.yunion.io'
	})
	localStorage.removeItem('userInfo')
	localStorage.removeItem('customerLevel')
	localStorage.removeItem('customers')
	setLoginContent.call($('.login-content'), true)
	$(".user-info").remove();
}

function getUsetInfot(token, callback) {
	const URL = `${HTTP_URL}/api/v1/auth/user`
	const LEVEL_URL = `${HTTP_URL}/api/v2/customer-level`
	const CAPABILITIES_URL = `${HTTP_URL}/api/v2/customers/capabilities`
	const auth = Base64.decode(token)
	if (auth) {
		const { session } = JSON.parse(auth)
		$.ajax({
			url: LEVEL_URL,
			type: 'GET',
			xhrFields: {
				withCredentials: true,
			},
			headers: {
				authorization: `Bearer ${session}`,
			},
			success: (ret) => callback(ret, 'customerLevel'),
		})
		$.ajax({
			url: CAPABILITIES_URL,
			type: 'GET',
			xhrFields: {
				withCredentials: true,
			},
			headers: {
				authorization: `Bearer ${session}`,
			},
			success: (ret) => {
				callback(ret, 'customers')
				$.ajax({
					url: URL,
					type: 'GET',
					xhrFields: {
						withCredentials: true,
					},
					headers: {
						authorization: `Bearer ${session}`,
					},
					success: (ret) => callback(ret.data, 'userInfo'),
					error: function ({status}) {
						if (status === 401) {
							logout()
						}
					}
				})
			}
		})
	}
}

function setUsetInfoHtml(data, customerStorage) {
	const me = this
	if (data) {
		const nameFirstWord = (_.get(data, 'name[0]') || '').toUpperCase()
		const htmlTmp = `<div class="dropdown" style="margin-left: 24px;">
			<span class="avatar-navbar">${nameFirstWord}</span>
			<a id="dLabel">
				${data.name}
				<i class="fa fa-caret-down" aria-hidden="true"></i>
			</a>
		</div>`
		me.append(htmlTmp)
		// console.log({ customerStorage, getLevelRole: getLevelRole(customerStorage) })
		$('#dLabel', me).popover({
			title: '--',
			html: true,
			placement: 'bottom',
			template: `
				<div class="dropdown-menu user-info" aria-labelledby="dLabel">
					<div class="avatar-wrapper d-flex align-items-center mb-3">
						<div class="avatar">${nameFirstWord}</div>
						<div class="text-left">
							<div>${data.name}</div>
							${customerStorage ? `<div class="identity d-inline-block mt-1 px-1">${getLevelRole(customerStorage).label}</div>` : ''}
						</div>
					</div>
					<div class="menus-wrapper m-2">
						<div class="user">
							<a class="user-btn info-btn" href="${HTTP_URL}/account">
								<i class="fa fa-user-o" aria-hidden="true"></i>
								账户信息
							</a>
						</div>
						<div class="channel">
							<a class="user-btn agent-btn" href="${HTTP_URL}/account/reportProject">
								<i class="fa fa-file-text-o" aria-hidden="true"></i>
								渠道报备
							</a>
						</div>
						<div class="admin">
							<a class="user-btn console-btn" href="${HTTP_URL}">
								<i class="fa fa-television" aria-hidden="true"></i>
								控制台
							</a>
						</div>
					</div>
					<div><a class="logout btn-logout"><i class="fa fa-sign-out mr-1" aria-hidden="true"></i>退出</a></div>
				</div>
			`
		})
		$('#dLabel', me).on('shown.bs.popover', function () {
			$('.user-info .logout').click(function () {
				logout()
			})
			const customerLevel = localStorage.getItem('customerLevel')
			const customerStorage = localStorage.getItem('customers')
			const userInfoStorage = localStorage.getItem('userInfo')
			const obj = Object.assign({}, JSON.parse(customerStorage), JSON.parse(customerLevel))
			setLevelHtml(obj)
			setUserHtml(JSON.parse(userInfoStorage || '{}'))
		})
	}
}

function getLevelRole (customerStorage) {
	const obj = { key: '', label: '' }
	if (customerStorage && Object.keys(customerStorage).length) {
		if (customerStorage.is_agent) { // 渠道商
			obj.key = 'channel'
			obj.label = '渠道用户'
		} else if (customerStorage.customer_level === 0 && customerStorage.customer_id) { // 普通用户
			obj.key = 'user'
			obj.label = '普通用户'
		} else if (customerStorage.customer_level === 1 || typeof(customerStorage.customer_id) == "undefined") { // 管理员
			obj.key = 'admin'
			obj.label = '管理员'
		}
	}
	return obj
}

function setLevelHtml (data) {
	if (data) {
		$('.user-info .menus-wrapper >div').css('display', 'none')
		const { key } = getLevelRole(data)
		switch (key) {
			case 'channel':
				$('.user-info .menus-wrapper .channel').css('display', 'block')
				break;
			case 'user':
				// $('.user-info .menus-wrapper .user').css('display', 'block')
				break;
			case 'admin':
				// $('.user-info .menus-wrapper .user').css('display', 'block')
				$('.user-info .menus-wrapper .admin').css('display', 'block')
				break;
		}
	}
}

function setUserHtml(userInfo) { 
	if (userInfo) { 
		const name = userInfo.name
		if (APPLY_LICENSE_ACCOUNTS.includes(name)) {
			$('.user-info .menus-wrapper .user').css('display', 'block')
			$('.user-info .menus-wrapper .admin').remove()
		} else {
			$('.user-info .menus-wrapper .user').remove()
		}
	}
}

function setLoginContent(isLogout) {
	const _this = this
	$(this).html()
	const href = window.location.href
	const loginUrl = `${HTTP_URL}/auth/login?source=${href}`
	const token = Cookies.get('yunionauth')
	const userInfo = localStorage.getItem('userInfo')
	const customerLevel = localStorage.getItem('customerLevel')
	const customerStorage = localStorage.getItem('customers')
	if (token && !userInfo) {
		if (!isLogout) { // 添加 isLogout 避免在logout的时候死循环
			getUsetInfot(token, function (data, localStorageKey) {
				if (data) {
					localStorage.setItem(localStorageKey, JSON.stringify(data))
					if (localStorageKey === 'userInfo') {
						setUsetInfoHtml.call(_this, data, JSON.parse(localStorage.getItem('customers')))
					}
				}
			})
		}
	} else if (!token) {
		// 语言切换：保持当前页面路径，仅替换语言前缀，不跳回首页
		let path = window.location.pathname
		const isEn = window.location.href.includes('/en')
		const enPath = isEn ? path.replace(/^\/en/, '') : '/en' + path
		const cnPath = isEn ? path.replace(/^\/en/, '') : path
		$(this).html(
			`<a href="${loginUrl}" style="margin-left: 25px;">${isEn ? 'Login' : '登录'}</a>` +
			`<a href="${isEn ? cnPath : enPath}" style="margin-left: 16px;">${isEn ? '中文' : 'English'}</a>`
		)
	}
	if (token && userInfo && customerStorage) {
		const customerStorageObj = JSON.parse(customerStorage)
		setUsetInfoHtml.call(_this, JSON.parse(userInfo), customerStorageObj)
		const obj = Object.assign({}, customerStorageObj, JSON.parse(customerLevel))
		setLevelHtml(obj)
	}
	if (token) {
		$('#cooperate-btn').hide()
	} else {
		$('#cooperate-btn').show()
	}
}

// 登录处理
setLoginContent.call($('.login-content'))

$(document).bind("mousedown", function (e) {
	var _targe = $(e.target);
	if (_targe.parents(".user-info").length > 0 || _targe.hasClass('user-info') || _targe.parents(".login-content").length > 0 || _targe.parents(".dropdown").length > 0) {
		return true;
	}
	$(".user-info").remove();
});


$('#cooperate-btn').attr('href', `${HTTP_URL}/auth/channel-partner-register?source=partner`)



// WEBPACK FOOTER //
// ./src/lib/app/js/app.js